import React from 'react';
import { Select2, Select2Props } from '@el8/vital';
import { timezoneOptions } from './TimezoneSelect.helpers';

type Props = Omit<Select2Props<string>, 'items' | 'labelKey' | 'disabled' | 'valueKey'>;

/**
 * A Select for picking American Timezones. These timezones
 * are statically known to the Select, and it does not allow
 * you to provide your own list of timezones. It also does
 * not let you provide a custom format for displaying the
 * timezone. This is done so that timezone display is done
 * so in a consistent way whereever it is used.
 */
const TimezoneSelect = (props: Props): JSX.Element => {
  return <Select2 {...props} items={timezoneOptions} />;
};

export default TimezoneSelect;
